function Button( {children, onClick, variant ='ptimary', size = 'md', type = 'button'} ){
      const baseStyles = "rounded-lg font-medium transition";

      const variants = {
        primary: "bg-[#0E5E92] text-white hover:bg-[#0B4A73] p-3",
        secondary: "bg-[#56A6CF] text-white hover:bg-[#3F8FB6] p-3",
        outline: "border border-[#0E5E92] text-[#0E5E92] hover:bg-[#0E5E92] hover:text-white"
      };

    return(
        <button
        
        type={type}
        onClick={onClick}
        className={`${baseStyles} ${variants[variant]}`}
        >
        {children}
        </button>
    )
}

export default Button;